import propTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useInfiniteQuery, useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { apirequest } from "../../../../API/api";
import { endpoint } from "../../../../API/config";
import useDebounce from "../../../../hooks/useDebounce";
import { reconcile } from "../../../../redux/features/learningPath/learningPathSlice";
import ModalButton from "../../../global/modal/ModalTemplate/ModalButton";
import WithFullScreenModal from "../../../global/modal/WithModal/WithFullScreenModal";
import BackNCancelButton from "./BackNCancelButton";
import Browse from "./Browse";
import BrowseLearningPath from "./BrowseLearningPath";

const getSearchParams = (url) => {
  const params = new URLSearchParams(url);
  return params;
};
const limit = 50;

function BrowseLPcontainer({ closeModal, learningPathId, setDisableSave }) {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [course, setCourse] = useState(null);
  const [variant, setVariant] = useState(null);
  const login_Details = useSelector((state) => state.loginData.LoginDetails);
  const [courseSearchKeyword, setCourseSearchKeyword] = useState("");
  const [variantSearchKeyword, setVariantSearchKeyword] = useState("");
  const courseDebouncedSearch = useDebounce(courseSearchKeyword, 500);
  const variantDebouncedSearch = useDebounce(variantSearchKeyword, 500);

  const importLearningPathData = useSelector(
    (state) => state.importLearningPathData.importLearningPathDetails
  );
  const courseIdForImportApi = useSelector(
    (state) => state.courseData.courseDetails.courseId
  );
  const variantIdForImportApi = useSelector(
    (state) => state.variantsByCourseData.variantsByCourse.variantId
  );
  const pathLink = useSelector(
    (state) => state.importLearningPathData.clipBoardData
  );

  const dispatch = useDispatch();

  /* Import Learning Path API */
  const fetch_importPath_Payload = async () => {
    return apirequest({
      url: `${endpoint.import_Learning_Path.addr}`,
      method: "post",
      data: {
        courseId: courseIdForImportApi.toString(),
        variantId: variantIdForImportApi,
        learningPathId,
        isActive: "1",
        createdBy: login_Details.userImsPin,
        data: importLearningPathData,
      },
    });
  };
  const { mutate: fetchImportPathAPI, isLoading } = useMutation({
    mutationFn: fetch_importPath_Payload,
    onSuccess: (data) => {
      // dispatch(addTier(data.data.data.data));
      dispatch(reconcile([data.data.data.data]));
      setDisableSave(false);
      alert(data?.data?.message || "Learning Path Imported Successfully");
      closeModal();
    },
    onError: (err) => {
      alert(err.data.message);
    },
  });

  function handleClick() {
    if (pathLink === "") {
      alert("Please Copy or Browse Link!");
    } else {
      fetchImportPathAPI();
    }
  }

  /* Course API */
  // const { refetch: fetchCourses, status: courseStatus } = useInfiniteQuery({
  //   queryKey: [`${endpoint.course_data.key}`, pageInfo.limit, pageInfo.page],
  //   queryFn: () =>
  //     apirequest({
  //       url: `${endpoint.course_data.addr}?pageNum=${pageInfo.page}&pageSize=${pageInfo.limit}`,
  //       method: "Post",
  //       data: {
  //         adminimspin: login_Details.userImsPin,
  //       },
  //     }),
  //   enabled: false,
  //   onSuccess: (res) => {
  //     setData({
  //       ...data,
  //       1: res.data.data.courseList,
  //     });
  //   },
  //   retry: 0,
  //   onError: (err) => {
  //     setCurrentScreen(currentScreen - 1);
  //     alert(err.response.data.message);
  //   },
  //   keepPreviousData: true,
  // });

  const {
    refetch: fetchCourses,
    status: courseStatus,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage: hextNextCoursePage,
  } = useInfiniteQuery({
    queryKey: [`${endpoint.course_data.key}`, courseDebouncedSearch],
    queryFn: ({ pageParam = 1 }) => {
      const payload = courseDebouncedSearch
        ? { searchKeyword: courseDebouncedSearch }
        : {};
      return apirequest({
        url: `${endpoint.course_data.addr}?pageNum=${pageParam}&pageSize=${limit}`,
        method: "Post",
        data: {
          adminimspin: login_Details.userImsPin,
          ...payload,
        },
      });
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.data?.data?.courseList?.length === 0) {
        return undefined;
      }

      const params = getSearchParams(lastPage.config.url.split("?")?.[1]);
      const pageNum = Number(params.get("pageNum"));
      return pageNum + 1;
    },
    onSuccess: (res) => {
      const coursesList = res.pages
        .map((page) => page?.data?.data?.courseList)
        .flat();

      setData((prev) => ({
        ...prev,
        1: [...(coursesList || [])],
      }));
    },
    // enabled: false,
    retry: 0,
    onError: (err) => {
      const params = getSearchParams(err?.config?.url?.split("?")?.[1]);
      const pageNum = Number(params.get("pageNum"));
      if (pageNum === 1) {
        setCurrentScreen(currentScreen - 1);
        alert(err.response.data.message);
      }
    },
  });

  /* Variants data by courseId */
  const fetchVariantData = ({ pageParam = 1 }) => {
    const payload = variantDebouncedSearch
      ? { searchKeyword: variantDebouncedSearch }
      : {};
    return apirequest({
      url: `${endpoint.getCourse_VariantsData.addr}?pageNum=${pageParam}&pageSize=${limit}`,
      method: "post",
      data: {
        courseId: course.courseId,
        ...payload,
      },
    });
  };

  const {
    status: variantStatus,
    fetchNextPage: fetchNextPageVariant,
    isFetchingNextPage: isFetchNextPageVariant,
    hasNextPage: hasNextPageVariant,
  } = useInfiniteQuery({
    queryKey: [
      `${endpoint.getCourse_VariantsData.key}`,
      course,
      variantDebouncedSearch,
    ],
    queryFn: fetchVariantData,
    onSuccess: (res) => {
      const variantList = res.pages.map((page) => page?.data?.data).flat();

      setData({
        ...data,
        2: variantList,
      });
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.data?.data?.length === 0) {
        return undefined;
      }
      const params = getSearchParams(lastPage.config.url.split("?")?.[1]);
      const pageNum = Number(params.get("pageNum"));
      return pageNum + 1;
    },
    onError: (err) => {
      const params = getSearchParams(err?.config?.url?.split("?")?.[1]);
      const pageNum = Number(params.get("pageNum"));

      // setCurrentScreen(currentScreen - 1);
      console.log("Err obj : ", err);
      if (pageNum === 1) {
        setError(err.data.message);
      }
    },
    retry: 0,
    enabled: !!course,
  });

  /* Learning path api call */
  const fetchLearningPathPayload = () => {
    return apirequest({
      url: `${endpoint.get_LearningPath_DataV2.addr}`,
      method: "post",
      data: {
        courseId: course.courseId,
        variantId: variant.variantId,
      },
    });
  };

  const { status: learningPathStatus } = useQuery(
    [endpoint.get_LearningPath_DataV2.key, course, variant],
    fetchLearningPathPayload,
    {
      onSuccess: (res) => {
        setData({
          ...data,
          3: res.data.data,
        });
      },
      onError: (err) => {
        setError(err.data.message);
      },
      enabled: !!variant,
      retry: 0,
    }
  );

  function returnStatus() {
    if (currentScreen === 1) return courseStatus;
    if (currentScreen === 2) return variantStatus;
    if (currentScreen === 3) return learningPathStatus;
  }

  const fetch = useCallback(() => {
    if (currentScreen === 1) {
      if (hextNextCoursePage) {
        fetchNextPage();
        return;
      }
    }
    if (currentScreen === 2) {
      if (hasNextPageVariant) {
        fetchNextPageVariant();
        return;
      }
    }
  }, [currentScreen, fetchNextPage, fetchNextPageVariant]);
  const clearSearchKeywords = useCallback(() => {
    setCourseSearchKeyword("");
    setVariantSearchKeyword("");
  }, []);

  return (
    <div
      className={`flex flex-col grow py-4 px-8 fixed inset-0 items-center ${
        currentScreen != 0
          ? " overflow-y-scroll scrollbar-thumb-secondary-700 scrollbar-thin scrollbar-thumb-rounded"
          : ""
      }`}
    >
      <BackNCancelButton
        closeModal={closeModal}
        currentScreen={currentScreen}
        setCurrentScreen={setCurrentScreen}
        setError={setError}
        setCourse={setCourse}
        setVariant={setVariant}
        clearSearchKeywords={clearSearchKeywords}
      />
      {(currentScreen === 1 || currentScreen === 2) && (
        <div className="pb-5 ml-auto">
          <input
            className="ml-5 max-w-[29rem] border-2 border-secondary-300 rounded-2xl pl-4 pr-5 py-3 border-solid  px-2  focus:outline-none placeholder-bold font-semibold text-XL"
            type="text"
            placeholder={
              currentScreen === 1 ? "Search Course" : "Search Variant"
            }
            autoFocus
            value={
              currentScreen === 1 ? courseSearchKeyword : variantSearchKeyword
            }
            onChange={(e) => {
              if (currentScreen === 1) {
                setCourseSearchKeyword(e.target.value);
                return;
              }
              if (currentScreen === 2) {
                setVariantSearchKeyword(e.target.value);
                return;
              }
            }}
          />
        </div>
      )}
      <div className="mb-16 w-full">
        {currentScreen == 0 ? (
          <BrowseLearningPath
            pathLink={pathLink}
            setCurrentScreen={setCurrentScreen}
            fetchCourses={fetchCourses}
          />
        ) : (
          <Browse
            currentScreen={currentScreen}
            setCurrentScreen={setCurrentScreen}
            data={data[currentScreen]}
            setData={setData}
            course={course}
            variant={variant}
            setCourse={setCourse}
            setVariant={setVariant}
            error={error}
            status={returnStatus()}
            fetchNextPage={fetch}
            isFetchingNextPage={isFetchingNextPage || isFetchNextPageVariant}
          />
        )}
      </div>

      {currentScreen === 0 && (
        <div className="mx-auto">
          <div className="w-32">
            <ModalButton
              isLoading={isLoading}
              modalButtonValue="Save"
              modalButtonFunctions={[handleClick]}
            />
          </div>
        </div>
      )}
    </div>
  );
}

BrowseLPcontainer.propTypes = {
  closeModal: propTypes.func,
  learningPathId: propTypes.string,
  setDisableSave: propTypes.func,
};

export default WithFullScreenModal(BrowseLPcontainer);
